var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.742,
    height: 106.614,
    viewBox: "0 0 104.742 106.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26861",
    "data-name": "Group 26861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26899",
    "data-name": "Group 26899",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23552",
    "data-name": "Path 23552",
    d: "M125.081,116.22a3.092,3.092,0,0,1-.461.531,1.156,1.156,0,0,1-1.718-.162,1.128,1.128,0,0,1,.072-1.648,1.153,1.153,0,0,1,1.651-.076,3.167,3.167,0,0,1,.456.536Z",
    transform: "translate(-20.34 -19.008)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23553",
    "data-name": "Path 23553",
    d: "M6.722,114.578c.305,0,.611-.018.915,0a1.229,1.229,0,0,1-.038,2.458c-.576.025-1.152.01-1.728.008a1.187,1.187,0,0,1-1.348-1.207c-.013-.848.531-1.271,1.385-1.268.271,0,.542,0,.813,0v.006",
    transform: "translate(-0.75 -19.011)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23554",
    "data-name": "Path 23554",
    d: "M118.016,117.035a8.088,8.088,0,0,1-1.016-.008,1.152,1.152,0,0,1-1.106-1.23,1.13,1.13,0,0,1,1.124-1.208c.641-.048,1.287-.027,1.931-.012a1.155,1.155,0,0,1,1.257,1.187,1.179,1.179,0,0,1-1.275,1.276c-.3.014-.61,0-.915,0v-.008",
    transform: "translate(-19.23 -19.009)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23555",
    "data-name": "Path 23555",
    d: "M2.492,115.868a1.174,1.174,0,0,1-1.279,1.162A1.217,1.217,0,1,1,1.3,114.6a1.176,1.176,0,0,1,1.192,1.271",
    transform: "translate(-0.006 -19.015)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23556",
    "data-name": "Path 23556",
    d: "M111.941,42.689a1.217,1.217,0,1,1-1.206-1.2,1.221,1.221,0,0,1,1.206,1.2m-1.211-.505a.521.521,0,0,0-.522.525.512.512,0,0,0,.5.52.523.523,0,1,0,.026-1.045",
    transform: "translate(-18.171 -6.884)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23557",
    "data-name": "Path 23557",
    d: "M5.478,12.333a1.217,1.217,0,1,1-1.206-1.2,1.221,1.221,0,0,1,1.206,1.2m-1.211-.505a.521.521,0,0,0-.522.525.512.512,0,0,0,.5.52.523.523,0,1,0,.026-1.045",
    transform: "translate(-0.505 -1.847)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23558",
    "data-name": "Path 23558",
    d: "M99.893,8.365A1.775,1.775,0,1,1,98.135,6.61a1.781,1.781,0,0,1,1.758,1.755m-1.766-.737a.761.761,0,0,0-.762.766.747.747,0,0,0,.724.757.77.77,0,0,0,.791-.741.778.778,0,0,0-.753-.782",
    transform: "translate(-15.986 -1.097)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23559",
    "data-name": "Path 23559",
    d: "M30.884,25.915a1.846,1.846,0,1,1-1.829-1.827,1.853,1.853,0,0,1,1.829,1.827m-1.837-.767a.792.792,0,0,0-.792.8.778.778,0,0,0,.753.787.8.8,0,0,0,.823-.772.811.811,0,0,0-.784-.813",
    transform: "translate(-4.512 -3.997)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23560",
    "data-name": "Path 23560",
    d: "M122.182,23.933a1.184,1.184,0,1,1-1.173-1.171,1.188,1.188,0,0,1,1.173,1.171m-1.177-.492a.508.508,0,0,0-.509.51.5.5,0,0,0,.483.505.508.508,0,1,0,.026-1.016",
    transform: "translate(-19.881 -3.777)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23561",
    "data-name": "Path 23561",
    d: "M53.086,1.171A1.184,1.184,0,1,1,51.913,0a1.188,1.188,0,0,1,1.173,1.171M51.909.679a.508.508,0,0,0-.509.51.5.5,0,0,0,.483.505A.514.514,0,0,0,52.41,1.2a.518.518,0,0,0-.5-.521",
    transform: "translate(-8.416 0)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23562",
    "data-name": "Path 23562",
    d: "M11.32,40.827H7.728a.209.209,0,1,1,0-.417H11.32a.209.209,0,1,1,0,.417",
    transform: "translate(-1.248 -6.705)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23563",
    "data-name": "Path 23563",
    d: "M10.659,42.037a.207.207,0,0,1-.175-.1L8.543,38.918a.208.208,0,0,1,.35-.225l1.941,3.023a.208.208,0,0,1-.063.288.2.2,0,0,1-.113.033",
    transform: "translate(-1.412 -6.404)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23564",
    "data-name": "Path 23564",
    d: "M8.718,42.037A.2.2,0,0,1,8.6,42a.208.208,0,0,1-.063-.288l1.941-3.023a.208.208,0,0,1,.35.225L8.893,41.941a.207.207,0,0,1-.175.1",
    transform: "translate(-1.412 -6.404)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23565",
    "data-name": "Path 23565",
    d: "M35.091,8.646H34.065l.555-.863a.151.151,0,1,0-.254-.163l-.577.9-.576-.9a.151.151,0,1,0-.254.163l.555.863H32.487a.151.151,0,1,0,0,.3h1.026l-.555.863A.151.151,0,0,0,33,10.02a.146.146,0,0,0,.082.024.15.15,0,0,0,.127-.07l.576-.9.577.9a.148.148,0,0,0,.127.07.142.142,0,0,0,.081-.024.15.15,0,0,0,.046-.209l-.554-.863h1.025a.151.151,0,1,0,0-.3",
    transform: "translate(-5.366 -1.253)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23566",
    "data-name": "Path 23566",
    d: "M64.081,13.516H60.953a.181.181,0,1,1,0-.363h3.128a.181.181,0,0,1,0,.363",
    transform: "translate(-10.084 -2.182)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23567",
    "data-name": "Path 23567",
    d: "M63.5,14.569a.181.181,0,0,1-.153-.083l-1.69-2.632a.181.181,0,1,1,.3-.2l1.691,2.632a.18.18,0,0,1-.055.25.172.172,0,0,1-.1.029",
    transform: "translate(-10.227 -1.92)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23568",
    "data-name": "Path 23568",
    d: "M61.814,14.569a.172.172,0,0,1-.1-.029.18.18,0,0,1-.055-.25l1.691-2.632a.181.181,0,1,1,.3.2l-1.69,2.632a.181.181,0,0,1-.153.083",
    transform: "translate(-10.227 -1.92)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23569",
    "data-name": "Path 23569",
    d: "M97.149,25.948H94.311a.165.165,0,0,1,0-.329h2.838a.165.165,0,0,1,0,.329",
    transform: "translate(-15.622 -4.251)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23570",
    "data-name": "Path 23570",
    d: "M96.627,26.9a.164.164,0,0,1-.138-.076l-1.533-2.388a.164.164,0,0,1,.277-.178l1.533,2.388a.164.164,0,0,1-.05.227.155.155,0,0,1-.088.027",
    transform: "translate(-15.752 -4.013)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23571",
    "data-name": "Path 23571",
    d: "M95.094,26.9a.155.155,0,0,1-.088-.027.164.164,0,0,1-.05-.227l1.533-2.388a.164.164,0,0,1,.277.178l-1.533,2.388a.164.164,0,0,1-.138.076",
    transform: "translate(-15.752 -4.013)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23572",
    "data-name": "Path 23572",
    d: "M0,115.2c.183-.193.355-.538.55-.551a2.659,2.659,0,0,1,1.544.162.967.967,0,0,1,.061,1.581,2.721,2.721,0,0,1-1.53.28c-.206,0-.417-.29-.626-.45V115.2",
    transform: "translate(0 -19.019)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23573",
    "data-name": "Path 23573",
    d: "M80.848,101.466q-4.348-4.321-8.7-8.642-.943-.937-1.879-1.881c-.988-1-.989-1.475-.026-2.494.16-.169.308-.352.432-.495l-3.733-3.731c-1.946.872-3.865,1.919-5.9,2.616a24.989,24.989,0,1,1,16.987-21.97,24.4,24.4,0,0,1-3.582,11.27c-.368.6-.409.951.138,1.457,1.1,1.018,2.119,2.119,3.136,3.149.147-.03.223-.023.26-.058,1.649-1.5,1.756-1.5,3.374.121,3.35,3.35,6.633,6.772,10.071,10.03a7.822,7.822,0,0,1,1.175,10.53,1.364,1.364,0,0,0-.078.336c1.029,0,2.028,0,3.028,0,1.146,0,1.713.443,1.683,1.3-.028.81-.545,1.187-1.681,1.187q-21.116,0-42.231,0H13.338c-.34,0-.772.117-1-.046-.42-.3-.989-.757-1-1.159s.526-.906.932-1.226c.213-.168.658-.052,1-.052h67.46l.118-.239M53.075,40.614a22.533,22.533,0,1,0,22.513,22.5,22.591,22.591,0,0,0-22.513-22.5M72.7,89.763c-.008-.02,0,.056.043.1,3.536,3.541,7.056,7.1,10.624,10.607a4.63,4.63,0,0,0,4.657,1.09A5,5,0,0,0,90.08,93.07c-3.319-3.373-6.685-6.7-10.034-10.043a2.472,2.472,0,0,0-.34-.264l-7.005,7M69.228,82.51,72.5,85.819l3.216-3.2-3.305-3.3L69.228,82.51",
    transform: "translate(-1.881 -6.331)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23574",
    "data-name": "Path 23574",
    d: "M63.8,26.032c0,.988-.006,1.977,0,2.965a1.236,1.236,0,0,1-1.177,1.4c-.714.081-1.287-.523-1.3-1.386-.023-1.977-.013-3.953-.005-5.931,0-.848.433-1.406,1.289-1.385.8.02,1.194.561,1.189,1.372-.005.988,0,1.977,0,2.965",
    transform: "translate(-10.173 -3.6)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23575",
    "data-name": "Path 23575",
    d: "M19.354,68.031c.953,0,1.908,0,2.861,0,.829.005,1.431.375,1.444,1.241s-.574,1.255-1.412,1.257q-2.911.006-5.823,0c-.818,0-1.4-.334-1.45-1.229-.043-.765.544-1.248,1.521-1.267.953-.019,1.908,0,2.861,0",
    transform: "translate(-2.484 -11.288)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23576",
    "data-name": "Path 23576",
    d: "M6.685,116.815c-.339,0-.679.02-1.016,0a1.141,1.141,0,0,1-1.16-1.177,1.167,1.167,0,0,1,1.178-1.273,14.073,14.073,0,0,1,1.931,0A1.162,1.162,0,0,1,8.823,115.6,1.148,1.148,0,0,1,7.6,116.817c-.3.015-.61,0-.915,0v0",
    transform: "translate(-0.748 -18.97)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23577",
    "data-name": "Path 23577",
    d: "M117.968,116.821c-1.53.01-2.135-.359-2.1-1.27.033-.853.638-1.2,2.087-1.2.339,0,.68-.018,1.017.009a1.183,1.183,0,0,1,1.224,1.233,1.148,1.148,0,0,1-1.211,1.228c-.339.018-.678,0-1.017,0",
    transform: "translate(-19.226 -18.973)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23578",
    "data-name": "Path 23578",
    d: "M123.841,116.832a1.162,1.162,0,0,1-1.219-1.22,1.217,1.217,0,1,1,2.434-.025,1.172,1.172,0,0,1-1.214,1.245",
    transform: "translate(-20.347 -18.979)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23579",
    "data-name": "Path 23579",
    d: "M60.6,80.577c-.738-.1-1.485-.166-2.212-.324a1.131,1.131,0,0,1-.96-1.433,1.158,1.158,0,0,1,1.437-.977,8.941,8.941,0,0,0,8.078-2.371,1.139,1.139,0,0,1,1.795.091,1.193,1.193,0,0,1-.2,1.8A11.446,11.446,0,0,1,60.6,80.577",
    transform: "translate(-9.524 -12.458)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23580",
    "data-name": "Path 23580",
    d: "M59.808,54.6c.676.073,1.355.123,2.025.227.809.124,1.326.566,1.231,1.446-.083.764-.772,1.153-1.7,1a8.71,8.71,0,0,0-6.607,1.414c-.361.251-.688.554-1.026.837-.757.636-1.48.681-1.965.06a1.26,1.26,0,0,1,.263-1.884,11.263,11.263,0,0,1,7.78-3.1",
    transform: "translate(-8.537 -9.06)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23581",
    "data-name": "Path 23581",
    d: "M62.644,122.826v1.259h4.5c.374,0,.823-.122,1.107.041a2.34,2.34,0,0,1,1.116,1.088c.187.655-.306,1.147-.983,1.314a3.429,3.429,0,0,1-.814.039q-7.2,0-14.405,0a4.677,4.677,0,0,1-.612-.013,1.2,1.2,0,0,1-1.184-1.287,1.149,1.149,0,0,1,1.27-1.179c1.294-.006,2.589,0,3.883-.008.3,0,.6-.029.97-.049.024-.372.046-.7.075-1.141-.423-.024-.782-.063-1.14-.063-2.691-.005-5.381,0-8.071,0-.305,0-.7.093-.9-.059-.416-.317-1-.762-1.008-1.169s.544-.887.953-1.2c.222-.172.657-.088,1-.088q11.647-.005,23.294,0c1.447,0,2.063.369,2.084,1.236.021.9-.615,1.285-2.129,1.286h-9",
    transform: "translate(-7.707 -19.959)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23582",
    "data-name": "Path 23582",
    d: "M29.645,102.556c-.318-.271-.8-.487-.908-.826a1.54,1.54,0,0,1,.153-1.3c1.461-1.568,2.987-3.079,4.533-4.564a1.219,1.219,0,0,1,1.718,1.718c-1.486,1.545-3.014,3.051-4.55,4.548a3.435,3.435,0,0,1-.947.421",
    transform: "translate(-4.756 -15.852)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23583",
    "data-name": "Path 23583",
    d: "M89.483,42.153c-1.153-.043-1.783-1.186-1.116-1.918,1.485-1.627,3.056-3.183,4.687-4.662a1.69,1.69,0,0,1,1.528.129,1.007,1.007,0,0,1,.092,1.61c-1.482,1.541-3,3.044-4.533,4.538a1.811,1.811,0,0,1-.658.3",
    transform: "translate(-14.618 -5.881)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23584",
    "data-name": "Path 23584",
    d: "M35.543,41.044c-.267.322-.478.806-.815.922a1.548,1.548,0,0,1-1.309-.14c-1.569-1.46-3.075-2.988-4.565-4.53a1.217,1.217,0,0,1,1.7-1.733c1.552,1.478,3.057,3.006,4.557,4.537a3.549,3.549,0,0,1,.432.944",
    transform: "translate(-4.73 -5.846)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23585",
    "data-name": "Path 23585",
    d: "M84.461,122.826c-.782,0-1.563.013-2.344,0s-1.346-.4-1.369-1.207c-.025-.867.557-1.284,1.381-1.3q2.343-.038,4.687,0c.828.013,1.4.446,1.368,1.309-.03.8-.6,1.181-1.38,1.2s-1.563,0-2.345,0",
    transform: "translate(-13.399 -19.961)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23586",
    "data-name": "Path 23586",
    d: "M39.6,122.824c-.782,0-1.563.017-2.345,0A1.216,1.216,0,0,1,35.9,121.6a1.189,1.189,0,0,1,1.3-1.274c1.631-.033,3.262-.035,4.892,0a1.176,1.176,0,0,1,1.254,1.214,1.2,1.2,0,0,1-1.3,1.272c-.813.034-1.63.007-2.445.009",
    transform: "translate(-5.957 -19.962)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23587",
    "data-name": "Path 23587",
    d: "M38.91,64.328A18.754,18.754,0,1,1,57.551,83.135,18.725,18.725,0,0,1,38.91,64.328m2.507.088a16.261,16.261,0,1,0,16.192-16.3,16.214,16.214,0,0,0-16.192,16.3",
    transform: "translate(-6.456 -7.573)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23588",
    "data-name": "Path 23588",
    d: "M68.908,57.54a2.219,2.219,0,0,1,1.852,1.678,1.349,1.349,0,0,1-1.294,1.3,2.183,2.183,0,0,1-1.734-1.742,1.23,1.23,0,0,1,1.176-1.239",
    transform: "translate(-11.239 -9.548)",
    fill: "#e4002b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23589",
    "data-name": "Path 23589",
    d: "M51.462,76.2a1.149,1.149,0,0,1,1.233-1.072,2.049,2.049,0,0,1,1.735,1.817A1.163,1.163,0,0,1,53.146,78.1a2.114,2.114,0,0,1-1.684-1.9",
    transform: "translate(-8.539 -12.466)",
    fill: "#e4002b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/nothingFound.0dba56d2ea3712c5289d613f8d4d78ab.svg";
export { ForwardRef as ReactComponent };